import React from 'react';
import { useSelector } from 'react-redux';
import { EcdStates } from '../../../root/ecd-model';
import { useEpiEcdRootPageContent } from '../../hooks/useEpiEcdRootPageContent';
import { ImageBlock } from '../../models/ecd-block-models';

export function AppHeader() {
    const siteSettingsLoaded = useSelector<EcdStates, boolean>(state => state?.epiProps?.siteSettingsState?.siteSettingsLoaded);
    const logoImage = useSelector<EcdStates, ImageBlock>(state => state?.epiProps?.siteSettingsState?.siteSettings?.logo);
    const ecdRootPage = useEpiEcdRootPageContent();

    if (!siteSettingsLoaded) return null;

    return (
        <header>
            <div className='adage-header'>
                <div className='adage-header-inner-lg'>

                    <a href={logoImage?.linkUrl} className='adage-header-logo'><img src={logoImage?.image} alt={logoImage?.imageAltText} /></a>

                </div>
                <div className='ecd-header'>
                    <div className='ecd-header-inner'>
                        <h2>{ecdRootPage?.headerTitle}</h2>
                    </div>
                </div>
            </div>
        </header>
    );
}